import { ManageByProgram, SubscriptionPrograms } from './../models/imanage.model';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
  Inject,
  AfterViewInit
} from '@angular/core';
import { ManageService } from '../services/manage.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { Cms } from '../cms/models/cms.model';
import { CmsStudioService } from '../cms/cms-studio.service';
import { CmsViewDirectiveService } from '../cms/cmsdirectives/cmsviewdirective.service';
import { IBreadcrumb } from '../breadcrumb/breadcrumb.interface';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { NgProgressService } from '../services/ngProgress.service';
import { filter, takeUntil } from 'rxjs/operators';
import { PanelService } from '../services/panel.service';
import { MatSidenav } from '@angular/material/sidenav';
import { WGSSubscriptionDetail } from '../models/wgs.model';
import { AdobeService } from '../services/adobe.service';
import { CommonService } from '../services';


@Component({
  selector: 'manage-subscriptions',
  templateUrl: './manage-subscriptions.component.html',
  styleUrls: ['./manage-subscriptions.component.css']
})
export class ManageSubscriptionsComponent implements OnInit, OnDestroy, AfterViewInit {

  title = 'Subscriptions';
  created = false;

  narrowMode = false;
  hideFirstLevel = false;
  loadContent = false;
  singleBlade = false;
  isStaffAccount: boolean = false;
  public showAddNewUserBtn = false;
  private user: CurrentUserModel;

  activePrograms: ManageByProgram[];
  dicoverPrograms: ManageByProgram[];

  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;
  @ViewChild(BreadcrumbComponent, {static: false}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb

  // css variable
  subWidth: string;

  // filter
  searchField = '';

  // router link
  routerLink = 'manageAnnuities';

  cms: Cms;
  viewChildId = null;
  public breadcrumbs: IBreadcrumb[] = [];
  cmsId: string = null;
  isBreadCrumbsUpdated = false;

  @ViewChild('rightPanel', { static: true }) private rightPanel: MatSidenav;

  constructor(
    private activeRouter: ActivatedRoute,
    private manageService: ManageService,
    private adobeService: AdobeService,
    private router: Router,
    private cmsservice: CmsStudioService,
    @Inject(CmsViewDirectiveService) private cmsViewDirectiveservice,
    @Inject(ViewContainerRef) private viewContainerRef,
    private activatedRoute: ActivatedRoute,
    public ngProgress: NgProgressService,
    private authService: AuthService,
    private commonService: CommonService,
    public panelService: PanelService
  ) {
    commonService.emitUpdateSideBarActiveItem('subscriptions');
  }

  ngOnInit() {
    // this.activatedRoute.params.subscribe(params => {
    //   if (params['cmsId']) {
    //     this.cmsId = params['cmsId'];
    //   }
    // });
    this.panelService.panel = this.rightPanel;

    this.activatedRoute.queryParamMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
      this.cmsId = params.get('cmsId');
      if (this.cmsId) {
      
        this.openCmsPage(this.cmsId);
      }
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(res => {
      this.breadcrumbRef.ngAfterViewInit();
    });

    // this.narrowMode = this.sharedService.getNarrowMode().subscribe(value => this.narrowMode = value != true ? false: true );
    // Initialize the narrow mod
    this.narrowMode = false;

    this.loadContent = false;

    this.activeRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }

      // this.manageService.getSubscriptionPrograms().pipe(takeUntil(this.ngUnsubscribe))
      //   .subscribe((value: SubscriptionPrograms) => {
      //     this.activePrograms = value.activePrograms;
      //     this.dicoverPrograms = value.discoverPrograms;
      //     if (this.cmsId) this.openCmsPage(this.cmsId);

      //     localStorage.setItem("subscriptionVendor", JSON.stringify(this.activePrograms));
      //     this.loadContent = true;
      //   },
      //     (error: any) => {
      //       console.info(error);
      //       this.loadContent = true;
      //     });
    });

    this.manageService.getOrRefreshProgramsSubject.asObservable()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.getOrRefreshPrograms();
      });
    this.getOrRefreshPrograms();

    // this.activatedRoute.queryParamMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(param => {
    //   let cmsId = param.get('cmsId');
    //   if (cmsId) {
    //     this.openCmsPage(cmsId);
    //     this.breadcrumbRef.breadcrumbs = this.breadcrumbs;
    //   }
    // });
    // IF an user refresh the web browser
    if (this.router.url !== '/manageSubscriptions') {
      this.narrowMode = true;
      this.loadContent = true;  // set to true to avoid load two loading screen at the same time

      if (this.router.url.includes('Details')) {
        this.hideFirstLevel = true;
      } else {
        this.hideFirstLevel = false;
      }

      if (this.router.url.split('/').length > 4) {
        this.singleBlade = true;
      } else {
        this.singleBlade = false;
      }
    }

    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (event.url === '/manageSubscriptions' || event.url === '/subscriptions') {

            this.narrowMode = false;

            $('.page-contents').animate({ scrollLeft: 0 }, 400);

          }
          // determine if it is manage details page or create new tenant page
          if (event.url.includes('Details')) {
            this.hideFirstLevel = true;

          } else {
            this.hideFirstLevel = false;
          }
        }
      });

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (user: CurrentUserModel) => {
        this.user = user;
        this.isStaffAccount = user.isStaffAccount;
        // if(user.hideSOH) {
        //   this.router.navigateByUrl('/home');
        // }
      }
    );

  }

  private getOrRefreshPrograms() {

    this.manageService.getSubscriptionPrograms().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: SubscriptionPrograms) => {

        // remove KASP
        this.activePrograms =  [ ...value.activePrograms ].filter(p => p.programType != 'KASP');
        this.dicoverPrograms = [ ...value.discoverPrograms ].filter(p => p.programType != 'KASP');

        this.activePrograms = [ ...this.activePrograms ];
        this.dicoverPrograms = [ ...this.dicoverPrograms ];
       
        const wgs = this.activePrograms.find(p => p.programType == "WGS");
        if (wgs) {
          this.manageService.setCurrentWGSContractResellerId(wgs.resellerId);
        }
        const amp = this.activePrograms.find(p => p.programType == "AMP");
        if (amp) {
          this.adobeService.setCurrentAMPResellerId(amp.resellerId);
        }
        // if (this.cmsId) { this.openCmsPage(this.cmsId); }

        localStorage.setItem('subscriptionVendor', JSON.stringify(this.activePrograms));
        this.loadContent = true;
      },
        (error: any) => {
          // tslint:disable-next-line:no-console
          console.info(error);
          this.loadContent = true;
        });
  }

  ngAfterViewInit() {

  }

  changeMode(event): void {
    event.preventDefault();
    event.stopPropagation();
    this.narrowMode = true;
  }

  navigateToEndUser(item: ManageByProgram): void {
    
    this.router.navigateByUrl(`/manageSubscriptions/manageAnnuities/${item.programType}`);

    // if (item.programType !== 'CSP' && item.programType !== 'ADY' && item.programType !== 'ADM') {
    //
    //   if (this.isStaffAccount) {
    //     this.router.navigateByUrl(`/manageSubscriptions/${item.programType}`);
    //   }
    //   else {
    //     this.router.navigateByUrl(`/manageSubscriptions/manageAnnuities/${item.programType}`);
    //   }
    //
    // } else {
    //   this.router.navigateByUrl(`/manageSubscriptions/manageAnnuities/${item.programType}`);
    // }

  }

  navigateToCmsPage(item: ManageByProgram): void {
    this.router.navigateByUrl(`/manageSubscriptions?cmsId=${item.cmsId}`);
  }

  isActive(programType?: string, cmsId?: string): boolean {
    const urlArray = this.router.url.split('/');
    return urlArray.indexOf(programType) > -1 || urlArray.indexOf(cmsId ? cmsId : null) > -1;
  }

  ngOnDestroy(): void {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/home');
    this.created = false;
  }

  closeCmsPage() {
    this.cms = null;
    this.router.navigateByUrl('/manageSubscriptions');
  }

  openCmsPage(id) {
    
    this.ngProgress.start();
    this.isBreadCrumbsUpdated = false;
    this.breadcrumbs = [];

    this.cmsservice.getCmsById(id)
      .subscribe(res => {
        this.cms = res.count;
        let index = -1;
        this.breadcrumbs.push({ label: 'Subscriptions', url: '/manageSubscriptions' });
        if (this.activePrograms && this.activePrograms.length > 0) {
          index = this.activePrograms.findIndex(ap => ap.cmsId === id);
        }
        if (index < 0 && this.dicoverPrograms && this.dicoverPrograms.length > 0) {
          index = this.dicoverPrograms.findIndex(ap => ap.cmsId === id);
        }
        if (index >= 0) {
          this.breadcrumbs.push({ label: this.cms.title, url: `/manageSubscriptions?cmsId=${id}` });
        }
        this.isBreadCrumbsUpdated = true;
        this.ngProgress.done();
      });

  }

  cmsClickEvent(e) {
    if (e.target.dataset.class === 'cmsTemplate' && this.viewChildId !== e.target.dataset.id) {
      jQuery('app-cms-view-directive').hide();
      this.cmsViewDirectiveservice.setRootViewContainerRef(this.viewContainerRef);
      this.cmsViewDirectiveservice.addDynamicComponent(e.target.dataset.id);
      // this.viewChildId = e.target.dataset.id;
      $('.page-contents').animate({ scrollLeft: $('app-kbtemplate').width() }, 400);
    }
  }

  gotoManageSubcriptionCms(id) {
    if (id) {
      this.router.navigate(['/manageSubscriptions', id]);
    }
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
}
